import { useEffect } from "react";
import { motion } from "framer-motion";

const LINES = [
  "> BOOTING CHEEKS.EXE ...",
  "> TURNING AROUND ...",
  "> DEPLOYING $PEPEBUTT ...",
  "> GM.",
];

export default function BootLoader({ onDone }) {
  useEffect(() => {
    const t = setTimeout(onDone, 2100);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div
      data-testid="boot-loader"
      onClick={onDone}
      exit={{ y: "-100%" }}
      transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
      className="fixed inset-0 z-[200] flex cursor-pointer items-center justify-center bg-nox"
    >
      <div className="w-full max-w-md px-8">
        {LINES.map((line, i) => (
          <motion.p
            key={line}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.25 + i * 0.42, duration: 0.05 }}
            className={`font-vt text-xl leading-relaxed sm:text-2xl ${
              i === LINES.length - 1
                ? "glow-neon text-neon"
                : "text-[#6b7f6b]"
            }`}
          >
            {line}
          </motion.p>
        ))}
        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ delay: 0.25, duration: 1.7, ease: "linear" }}
          className="mt-6 h-px origin-left bg-neon"
        />
      </div>
    </motion.div>
  );
}
